module.exports = __webpack_public_path__ + "static/img/social5-1x.384dfeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social5-1x.jpg
// module id = 9aer
// module chunks = 0